import { isNullOrUndefined } from './typeChecks';

export function isArrayLike<T>(obj: T | T[]): obj is T[] {
	return Array.isArray(obj) || isObservableArray(obj);
}

export function isObservableArray(obj: any) {
	return (
		typeof obj !== 'string' &&
		!isNullOrUndefined(obj) &&
		!isNullOrUndefined(obj.length) &&
		!isNullOrUndefined(obj.slice) &&
		typeof obj.slice === 'function'
	);
}